import React from 'react';

export type InspectorEmptyVariant = 'docked' | 'sheet';

export const InspectorEmptyState: React.FC = () => (
  <div
    style={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 9,
      padding: '40px 34px',
      textAlign: 'center',
    }}
  >
    <span
      style={{
        width: 40,
        height: 40,
        borderRadius: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--z-fill-2)',
        color: 'var(--z-dim)',
      }}
    >
      <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round">
        <path d="M9 4h9a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H9M9 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h3M9 4v16" />
      </svg>
    </span>
    <span style={{ fontSize: 14, fontWeight: 600, color: 'var(--z-text-3)' }}>
      Nada seleccionado
    </span>
    <p style={{ margin: 0, fontSize: 12.5, lineHeight: 1.6, color: 'var(--z-dim)', maxWidth: 250 }}>
      Elige una fila y su detalle nativo con contexto cruzado se abre aquí, sin perder de vista la lista.
    </p>
  </div>
);

export function renderInspectorEmpty(
  variant: InspectorEmptyVariant,
  Shell: React.FC<{ children: React.ReactNode; variant: InspectorEmptyVariant }>,
): React.ReactElement | null {
  if (variant === 'sheet') return null;
  return (
    <Shell variant={variant}>
      <InspectorEmptyState />
    </Shell>
  );
}
